var React = require('react');

function Help (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.75","y":"0.75","width":"18.5","height":"18.5","rx":"9.25","stroke":"#001D3B","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M8.41403 13.89C8.41403 14.576 8.94603 15.08 9.63203 15.08C10.318 15.08 10.864 14.576 10.864 13.89C10.864 13.204 10.318 12.686 9.63203 12.686C8.94603 12.686 8.41403 13.204 8.41403 13.89ZM8.76403 7.534C8.80603 7.128 9.15603 6.68 9.77203 6.68C10.374 6.68 10.78 7.03 10.78 7.548C10.78 8.654 8.54003 8.976 8.54003 10.782C8.54003 11.566 9.03003 12.126 9.18403 12.308L10.598 11.328C10.472 11.202 10.36 11.062 10.36 10.824C10.36 9.984 12.6 9.578 12.6 7.52C12.6 6.078 11.354 5 9.77203 5C8.24603 5 7.25203 5.966 7.00003 7.072L8.76403 7.534Z","fill":"#001D3B","key":1})]);
}

Help.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Help;

Help.default = Help;
